module.exports = __webpack_public_path__ + "static/media/popup-error.e0d8beb5.svg";